import React from 'react'

import { useStoreActions, useStoreState } from 'store'
import CurrencyInput from 'components/shared/CurrencyInput'

export default function PriceAndDownPayment() {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updatePrice } = useStoreActions(actions => actions.dimensions)
  const price = useStoreState(state => state.dimensions.dimensions.purchase.price)
  const dimensionsValidation = useStoreState(state => state.dimensions.dimensionsValidation)

  const handlePriceUpdate = (value: number) => {
    if (value !== undefined && value !== price) {
      updatePrice(value)
      onInputTracking({ name: 'purchaseprice', label: 'purchase price', value })
    }
  }

  return (
    <div className="md:w-full form-element-container mb-4 sm:mb-8 md:mb-6">
      <label className="FormLabel" htmlFor="purchasePrice">
        Purchase price
      </label>
      <CurrencyInput
        value={price}
        id="purchasePrice"
        testid="purchasePrice"
        update={handlePriceUpdate}
        invalid={dimensionsValidation.purchase.price.invalid || dimensionsValidation.purchase.minLtvRatio.invalid}
        errorMsg={
          dimensionsValidation.purchase.price.invalid
            ? dimensionsValidation.purchase.price.errorMsg
            : dimensionsValidation.purchase.minLtvRatio.errorMsg
        }
      />
    </div>
  )
}
